import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Button, message, Modal } from 'antd';

import ModelServices from '@accreditamento/services/Accreditamento';

import CommonForm from '@common/components/form';

import checkPermission from '@common/utils/check/permissions';

const formNoteLayout = {
  layout: 'vertical',
  multistep: false,
  rows: [
    {
      cols: [
        {
          items: [
            {
              type: 'radio',
              label: 'Scheda valida?',
              name: 'valid',
              option_type: 'button', // normal|button
              options: [
                {
                  value: true,
                  label: "Si"
                },
                {
                  value: false,
                  label: "No"
                }
              ],
              props: {

              },
            }
          ],
        },
        {
          items: [
            {
              type: 'textarea',
              label: 'Note',
              name: 'note',
              props: {

              },
              validations: [
                // valido più avanti
                /*
                {
                  type: 'required',
                  error_message: 'Campo obbligatorio',
                },
                */
              ],
            },
          ],
        },

      ],
    }
  ],
  onSubmit: 'submitted',
};




class ValidationScheda extends Component {

  state = {
    loaded: false,
    accreditamento: {
      id: null
    },
    audit: {},
    open_modal_validate: false,
    loading: false
  }


  isIstruttore() {
    return checkPermission.hasPermission(this.props.UserStore.user, ['istruttorePermissions']) &&
      this.props.accreditamento.istruttore?.some(i => i.id === this.props.UserStore.user.id);
  }

  isEnte() {
    return (this.props.accreditamento.id_user === this.props.UserStore.user.id) ? true : false;
  }

  canGiveFeedback() {
    return this.isIstruttore() && this.props.accreditamento.stato_flusso === 6 &&
      this.props.progress.showed_sections[this.props.section];
  }

  render() {
    return <div>{
    this.canGiveFeedback() ?
        <React.Fragment>
          <Button
            loading={this.state.loading}
            disabled={false}/* TASK 413939... integrazione multipla -> NON DISABILITARE {this.props.accreditamento.istruttore_sections_feedback && this.props.accreditamento.istruttore_sections_feedback[this.props.section]} */
            className="m5h" type="primary" icon="edit" onClick={()=> {
              this.setState({ open_modal_validate: true }, () => { // Una volta aperta la modale avvia la callback per settare il valore di partenza della stessa
                if (!this.formNoteRef?.props?.form) return;

                const isValid = this.formNoteRef.props.values.valid !== false; // Calcola il valore dinamicamente in base allo stato della scheda
                
                this.formNoteRef.props.form.setFieldsValue({ valid: isValid });
              });
            }}
            style={{marginRight: 8}}>
            Conferma scheda
          </Button>
          <Modal
            title="Inserisci note"
            confirmLoading={this.state.loading}
            visible={this.state.open_modal_validate}
            forceRender={true}
            onOk={async () => {
                if(this.formNoteRef.props.form.getFieldsValue()['valid'] === false && (!this.formNoteRef.props.form.getFieldsValue()['note'] || this.formNoteRef.props.form.getFieldsValue()['note'] === '')) {
                  // Se la scheda non è valida il campo note diventa obbligatoria
                  message.error('Per le schede non valide è obbligatorio inserire delle note');
                  return;
                }

                if(!this.state.loading) {
                  this.setState({
                    loading: true,
                  }, () => {

                  ModelServices.feedbackSection(
                    this.props.accreditamento.id,
                    {
                      section: this.props.section,
                      note: this.formNoteRef.props.form.getFieldsValue()['note'],
                      valid: this.formNoteRef.props.form.getFieldsValue()['valid']
                    },
                    (res) => {
                      this.props.refreshInline(res.data.data);
                      this.setState({open_modal_validate: false, loading: false});
                    },
                    (err) => this.setState({loading: false})
                  );
                });
              }
              
            }}
            onCancel={() => this.setState({ open_modal_validate: false })}
          >
            <CommonForm
              wrappedComponentRef={inst => (this.formNoteRef = inst)}
              loading={this.state.loading || false}
              form_model={formNoteLayout}
              values={
                this.props.accreditamento && this.props.accreditamento.istruttore_sections_feedback ?
                this.props.accreditamento.istruttore_sections_feedback[this.props.section] || {valid: true, note: ''} :
                {valid: true, note: ''}
              }
            />
          </Modal>
        </React.Fragment>
          : null
        }
        {
          // questa sezione si deve vedere se
          // - l'utente è Istruttore e ci sono note
          // OPPURE
          // - l'utente è Ente e la domanda è in integrazione (e ci sono note)
          (this.isIstruttore() && this.props.accreditamento.istruttore_sections_feedback && this.props.accreditamento.istruttore_sections_feedback[this.props.section])
          ||
          (this.isEnte() && this.props.accreditamento.stato_flusso == 11 && this.props.accreditamento.istruttore_sections_feedback && this.props.accreditamento.istruttore_sections_feedback[this.props.section])
          ?
          <div>
            <p>{this.props.accreditamento.istruttore_sections_feedback[this.props.section].note}<br />
            <strong>Scheda {!this.props.accreditamento.istruttore_sections_feedback[this.props.section].valid ? 'non ' : ''}valida</strong></p>
          </div>
          : null
        }
      </div>
  }
}

const AuditExport = connect(({ UserStore, GlobalStore }) => ({ UserStore, GlobalStore }))(ValidationScheda);

export default withRouter(AuditExport);
